export default function Privacy() {
    return (
      <div className="bg-gray-100 min-h-screen">
        <div className="max-w-4xl mx-auto px-4 py-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">Privacy and Policy</h1>
          <p className="text-gray-700 leading-relaxed mb-6">
            Welcome to Alfa Entrepreneur. We value your privacy and are committed to protecting your personal
            information. This Privacy Policy outlines how we collect, use, and protect your data when you access
            or use our website and services.
          </p>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Information We Collect</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            We collect personal information that you voluntarily provide to us when you register on the website,
            subscribe to newsletters, participate in community discussions, or use any of our services. The
            information we collect includes:
          </p>
          <ul className="list-disc list-inside text-gray-700 mb-6">
            <li>Name and contact details (email address)</li>
            <li>Account login information</li>
            <li>Profile information (profile picture)</li>
            <li>Usage data (pages visited, interactions)</li>
            <li>Communication preferences</li>
          </ul>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">How We Use Information</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            We use the collected data to:
          </p>
          <ul className="list-disc list-inside text-gray-700 mb-6">
            <li>Personalize your experience on our platform</li>
            <li>Improve website functionality and performance</li>
            <li>Send newsletters and promotional content (with your consent)</li>
            <li>Analyze website usage to improve user experience</li>
            <li>Respond to inquiries and provide customer support</li>
          </ul>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Cookies and Tracking Technologies</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            Our website uses cookies and similar tracking technologies to monitor and store data about your
            visit. You can adjust your browser settings to manage or block cookies, but doing so may affect
            your experience on our site.
          </p>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Data Sharing and Third Parties</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            We do not sell, trade, or otherwise transfer your personal information to third parties without
            your consent, except as required by law. We may share data with trusted partners to provide better
            services, such as analytics or payment processing, under strict confidentiality agreements.
          </p>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Data Security</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            We implement security measures to protect your personal data from unauthorized access, alteration,
            or disclosure. While we strive to safeguard your information, we cannot guarantee absolute security
            due to the nature of the internet.
          </p>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Your Rights</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            You have the right to access, update, or delete your personal information. To exercise these rights,
            please contact us at <a href="mailto:support@alfaentrepreneur.com" className="text-indigo-600 hover:underline">support@alfaentrepreneur.com</a>.
          </p>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Changes to This Privacy Policy</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
            We may update this Privacy Policy periodically. Any changes will be posted on this page with 
            the updated effective date.
            </p>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Contact Us</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
            If you have any questions or concerns about this Privacy Policy, 
            please reach out to us at <a href="mailto:support@alfaentrepreneur.com" className="text-indigo-600 hover:underline">support@alfaentrepreneur.com</a>.
            </p>    
        </div>
      </div>
    );
  }